import useCrud from "../../../../hooks/useCrud";
import { ACTIONS, COLUMN_TYPE, CONTAS_A_RECEBER_VALUES_DEFAULT } from "../../../../utils/financialHelper";
import FormContasAReceber from "./FormContasAReceber";
import CrudTablePage from "../../../../components/Financial/CrudTablePage";

const ContasAReceber = () => {
  const headCells = [
    { key: 'name', field: 'name', type: COLUMN_TYPE.STRING, alignRight: false, label: 'Nome' },
    { key: 'payer', field: 'payer', type: COLUMN_TYPE.STRING, alignRight: true, label: 'Pagador' },
    { key: 'cpfCnpj', field: 'cpfCnpj', type: COLUMN_TYPE.STRING, alignRight: true, label: 'CPF/CNPJ' },
    { key: 'dueDate', field: 'dueDate', type: COLUMN_TYPE.DATE, alignRight: true, label: 'Vencimento' },
    { key: 'amount', field: 'amount', type: COLUMN_TYPE.MONEY, alignRight: true, label: 'Valor' },
    { key: 'actions', field: 'actions', type: COLUMN_TYPE.BUTTONS, alignRight: true, label: 'Ações' },
  ];

  const funcionalidade = 'Contas a Receber'

  const {
    action,
    buttonLabel,
    dadoFoiModificado,
    filterValue,
    isLoading,
    isLoadingSubmit,
    items: contasAReceber,
    open,
    title,
    values,
    setAction,
    setButtonLabel,
    setDadoFoiModificado,
    setFilterValue,
    setItems: setContasAReceber,
    setValues,
    handleClose,
    handleDelete,
    handleEdit,
    handleOpen,
    handleSubmit,
    handleView,
    handleClone,
  } = useCrud('/billings-receivable', CONTAS_A_RECEBER_VALUES_DEFAULT, funcionalidade);

  return (
    <CrudTablePage
      isLoading={isLoading}
      funcionalidade={funcionalidade}
      rows={contasAReceber}
      setRows={setContasAReceber}
      headCells={headCells}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
      handleClone={handleClone}
      filterValue={filterValue}
      setFilterValue={setFilterValue}
      dadoFoiModificado={dadoFoiModificado}
      setDadoFoiModificado={setDadoFoiModificado}
      open={open}
      title={title}
      buttonLabel={buttonLabel}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      action={action}
      handleOpen={handleOpen}
    >
      <FormContasAReceber
        values={values}
        setValues={setValues}
        isDelete={action === ACTIONS.DELETE}
        isLoadingSubmit={isLoadingSubmit}
      />
    </CrudTablePage>
  )
}
export default ContasAReceber;